/**
 * Client-side auth utilities
 * Use these in Client Components
 */

'use client';

import { useSession as useNextAuthSession } from 'next-auth/react';

export { useSession, SessionProvider } from 'next-auth/react';

/**
 * Hook to check if user is authenticated
 */
export function useAuth() {
  const { data: session, status } = useNextAuthSession();
  return {
    user: session?.user,
    isAuthenticated: status === 'authenticated',
    isLoading: status === 'loading',
  };
}
